import Box from 'component/layoutComponents/Box';
import React, { memo } from 'react';
import { TextGray, TextBlack, StyledButton } from '../ProductDetail.styles';

const ComplexButton = ({
  checked,
  onClick,
  label,
  detail,
  icon,
}: {
  checked: boolean;
  onClick: (isChecked: boolean) => void;
  label: string;
  detail: string;
  icon: JSX.Element;
}) => {
  return (
    <Box height="50px">
      <StyledButton  checked={checked} onClick={() => onClick(!checked)}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            {icon && <Box pr="12px">{icon}</Box>}
            <TextBlack>{label}</TextBlack>
          </Box>
          <Box>
            <TextGray fontWeight="bold" variant='body2' color="text.secondary">{detail}</TextGray>
          </Box>
        </Box>
      </StyledButton>
    </Box>
  );
};

export default memo(ComplexButton);
